import RawHtml from './RawHtml';

export default RawHtml;
